function formatDate(date) {

  date = new Date(date)
  return date.getFullYear() + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + ('0' + date.getDate()).slice(-2) + '. ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2)
  //return date.toISOString().split('T')[0];
}

function formatDateOnly(date) {

  date = new Date(date)
  return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
  //return date.toISOString().split('T')[0];
}

function formatNumber(number) {
  number = parseInt(number)
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}

function login(socket, authStore, cb) {
  socket.emit('Login', {
    Email: authStore.email,
    Pin: authStore.pin
  }, (err, data) => {
    if(err) {
      console.error(err);
      authStore.setUser(null);
    } else {
      authStore.setUser(data);
    }
    if(cb) {
      cb(err, data);
    }
  });
}

export {
  formatDate, formatDateOnly, formatNumber, login
};